export default {
  nav_home: 'Home',
  nav_guide: 'USFans Spreadsheet Guide',
  nav_shopping_guide: 'Shopping Guide',
  nav_categories: 'Categories',
  nav_browse: 'Browse Categories',
  lang_label: 'Language',
  footer_tagline: 'An independent, organized hub of USFans Spreadsheet resources, guides and safety tips.',
  footer_categories: 'Categories',
  footer_resources: 'Resources',
  footer_guide: 'USFans Spreadsheet Guide',
  footer_home: 'Home',
  footer_disclaimer: 'This is an independent information website and is not the official USFans website.',
  footer_rights: 'All rights reserved.',
  footer_visit_main: 'Visit Main Website',
};